import { render, staticRenderFns } from "./ItemsNeeded.vue?vue&type=template&id=6c3d9214&scoped=true"
import script from "./ItemsNeeded.vue?vue&type=script&lang=js"
export * from "./ItemsNeeded.vue?vue&type=script&lang=js"
import style0 from "./ItemsNeeded.vue?vue&type=style&index=0&id=6c3d9214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3d9214",
  null
  
)

export default component.exports